import AtMentionTag from "./AtMentionTag";
import { parseMentions, splitMentionName } from "./mentionHelpers";

export default function MentionedText({ content }: { content: string }) {
  const segments = parseMentions(content);
  if (!segments.some((segment) => segment.type === "mention")) {
    return <>{content}</>;
  }

  return (
    <>
      {segments.map((segment, index) =>
        segment.type === "text" ? (
          <span key={index}>{segment.text}</span>
        ) : (
          <AtMentionTag
            key={index}
            user={{
              id: segment.userId,
              ...splitMentionName(segment.name),
              email: ""
            }}
          />
        )
      )}
    </>
  );
}
